import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const PostCloseOccupancy = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      {contract?.contingency?.postCloseOccupancyDays && (
        <>
          <Text style={styles.title}>Post-Close Occupancy</Text>

          <View style={styles.list}>
            <Text style={styles.listItem}>
              1. Buyer shall allow Seller to remain in the Property for up to{' '}
              <Text style={styles.bold}>
                {contract?.contingency?.postCloseOccupancyDays ?? 'N/A'}
              </Text>{' '}
              days after closing ("Post-Close Occupancy")
            </Text>

            <Text style={styles.listItem}>
              2. Seller shall pay Buyer{' '}
              <Text style={styles.bold}>
                ${contract?.contingency?.postCloseOccupancyRent ?? 'N/A'}
              </Text>{' '}
              per day for the Post-Close Occupancy.
            </Text>

            <Text style={styles.listItem}>
              3. Seller shall pay Buyer a security deposit of{' '}
              <Text style={styles.bold}>
                ${contract?.contingency?.postCloseOccupancyDeposit ?? 'N/A'}
              </Text>{' '}
              for the Post-Close Occupancy.
            </Text>

            <Text style={styles.listItem}>
              4. Seller shall pay Buyer for any damages to the Property during
              the Post-Close Occupancy.
            </Text>

            <Text style={styles.listItem}>
              5. Any further terms relating to post-close occupancy are as
              follows:{' '}
              <Text style={styles.bold}>
                {contract?.contingency?.postCloseOccupancyTerms ?? 'N/A'}
              </Text>
            </Text>
          </View>
        </>
      )}
    </View>
  );
};

export default PostCloseOccupancy;
